import { authedFetch } from '@/lib/authed-fetch';
import type { Database } from '@sixam/shared/database.types';

export type Friendship = Database['public']['Tables']['friendships']['Row'];

export type FriendListItem = Readonly<{
  direction: 'inbound' | 'outbound';
  friend: {
    avatarUrl: string | null;
    fullName: string | null;
    id: string;
  };
  friendship: Friendship;
}>;

export async function fetchFriends(): Promise<FriendListItem[]> {
  const response = await authedFetch('/api/friends');
  const payload = (await response.json().catch(() => null)) as {
    error?: string;
    friendships?: FriendListItem[];
  } | null;

  if (!response.ok) {
    throw new Error(payload?.error ?? 'Could not load friends.');
  }

  return payload?.friendships ?? [];
}

export async function acceptFriendRequest(friendshipId: string): Promise<void> {
  const response = await authedFetch('/api/friends', {
    body: JSON.stringify({ friendshipId }),
    headers: { 'Content-Type': 'application/json' },
    method: 'PATCH',
  });
  const payload = (await response.json().catch(() => null)) as { error?: string } | null;

  if (!response.ok) {
    throw new Error(payload?.error ?? 'Could not accept friend request.');
  }
}
